import { lazy } from 'react';

const YtdAnalysisReport = lazy(() => import('./YtdAnalysisReport'));

const YtdAnalysisReportConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/sales/reports/ytdAnalysisReport', 
            element: <YtdAnalysisReport />,
        },
    ],
};

export default YtdAnalysisReportConfig;